module.exports = __webpack_public_path__ + "img/icon-4.3b128412.png";